<div class="wm-dialog-inner" [ngClass]="{ mobile: (isMobile$ | async) === true }">
  <div mat-dialog-title>
    <img class="wm-dialog-inner__image" *ngIf="data.image && data.imageAlt" [src]="data.image" [alt]="data.imageAlt" />
    <h1 class="wm-dialog-inner__title" [ngClass]="{ 'mat-subtitle-1': (isMobile$ | async) === true, 'mat-headline-4': (isMobile$ | async) === false }">{{ data.title | translate }}</h1>
  </div>

  <div mat-dialog-content *ngIf="form">
    <h2 *ngIf="data.subtitle">{{ data.subtitle | translate }}</h2>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <ng-container *ngFor="let field of data.fields">
        <ng-container [ngSwitch]="field.type">
          <mat-form-field *ngSwitchCase="'input'" appearance="outline" class="wm-input" [ngClass]="{ small: field.inputSize === 'small' }">
            <input matInput type="text" [placeholder]="field.label | translate" [formControlName]="field.name" [mask]="field.mask || ''" [allowNegativeNumbers]="field.allowNegativeNumbers" />
            <!-- <mat-error *ngIf="form.controls[field.name].hasError('required')"> {{ field.label }} is required </mat-error> -->
            <!-- <mat-error *ngIf="form.controls[field.name].hasError('email')"> Please enter a valid email address </mat-error> -->
          </mat-form-field>

          <mat-form-field *ngSwitchCase="'select'" appearance="outline" class="wm-select">
            <mat-select [formControlName]="field.name" [multiple]="field?.multiple" panelClass="wm-select-panelClass" [placeholder]="field.label | translate">
              @for (option of field.options; track option) {
              <mat-option [value]="option.value">
                {{ option.label | translate }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-checkbox *ngSwitchCase="'checkbox'" [formControlName]="field.name" ngDefaultControl color="accent">
            {{ field.label | translate }}
          </mat-checkbox>

          <p *ngSwitchCase="'paragraph'" class="paragraph">
            {{ field.label | translate }}

            <span *ngIf="field.value">{{ '- ' + field.value | translate }}</span>
          </p>

          <p *ngSwitchCase="'link'" class="link">
            <a href="{{ field.link }}">{{ field.label | translate }}</a>
          </p>

          <p *ngSwitchCase="'paragraph-link'" class="paragraph-link">
            <span>{{ field.paragraphLabel | translate }}&nbsp;</span>
            <span class="link">
              <a href="{{ field.link }}">{{ field.linkLabel | translate }}</a>
            </span>
          </p>

          <p *ngSwitchCase="'qr'">
            <qrcode [qrdata]="field.qrUrl" [width]="150" [errorCorrectionLevel]="'M'"></qrcode>
          </p>

          <div *ngSwitchCase="'yandexMap'" class="yandex-map">
            <ya-map [state]="mapState" (yaclick)="yaclick($event)" (ready)="onMapReady($event)" (balloonopen)="balloonopen($event)" [center]="[40, 44]" [zoom]="7">
              <ya-placemark
                *ngIf="fromClick && form.controls['latitude'].value !== null && form.controls['longitude'].value !== null"
                [geometry]="[form.controls['latitude'].value, form.controls['longitude'].value]"
              >
              </ya-placemark>
            </ya-map>
          </div>

          <div *ngSwitchCase="'qrcode'" style="text-align: center; min-height: 220px">
            <ng-container *ngIf="tfaSecretKey">
              <qrcode [qrdata]="tfaSecretKey.qrUrl" [width]="150" [errorCorrectionLevel]="'M'"></qrcode>

              <h5 class="mb-1">{{ 'WM_TECH_POOL.TFA.DIALOG.SUBTITLE_2' | translate }}</h5>
              <div class="flex">
                <p>{{ tfaSecretKey.secretKey | cutString }}</p>
                <wm-libs-copy-loader [valueForCopy]="tfaSecretKey.secretKey"></wm-libs-copy-loader>
              </div>
            </ng-container>
          </div>

          <div *ngSwitchCase="'pool-connect-template'">
            <ng-container *ngIf="connectData">
              <p class="mat-body-1 step-1 bold">1. {{ 'WM_TECH_POOL.CONNECT.DIALOG.STEP_1' | translate }}</p>

              <ng-container *ngFor="let item of connectData | keyvalue">
                <div class="flex mt-1">
                  <p class="mat-body-2 capitalize" style="flex: 1">{{ item.key }}:</p>
                  <mat-form-field appearance="outline" class="wm-input" style="flex: 1">
                    <input matInput [placeholder]="'WM_TECH.FORMS.EMAIL' | translate" type="email" [value]="item.value" readonly />
                    <wm-libs-copy-loader [valueForCopy]="item.value"></wm-libs-copy-loader>
                  </mat-form-field>
                </div>
              </ng-container>

              <p class="mat-body-1 step-2 bold mt-2 mb-1">2. {{ 'WM_TECH_POOL.CONNECT.DIALOG.STEP_2' | translate }}</p>

              <div class="action" align="end">
                <button mat-raised-button color="pool-button-bg-primary" class="dialog-button learn bottom" mat-button (click)="openLearnMore()">
                  {{ 'WM_TECH_POOL.CONNECT.DIALOG.LEARN_MORE' | translate }}
                </button>
                <p class="bottom mat-caption mt-1">
                  {{ 'WM_TECH_POOL.CONNECT.DIALOG.CAPTION' | translate }}
                </p>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </form>
  </div>
  <div mat-dialog-actions *ngIf="data?.submit !== false">
    <ng-container *ngIf="form; else ConfirmTemplate">
      <button
        mat-raised-button
        [color]="data?.app === 'pool' ? 'pool-button-bg-primary' : data?.app === 'mms' ? 'mms-button-bg-primary' : 'tech-button-bg-primary'"
        mat-button
        [disabled]="!form.valid"
        (click)="onSubmit()"
      >
        {{ data?.submitLabel || 'WM_TECH_MMS.DIALOG.SUBMIT' | translate }}
      </button>
    </ng-container>
    <ng-template #ConfirmTemplate>
      <button mat-raised-button [color]="data?.app === 'pool' ? 'pool-button-bg-primary' : data?.app === 'mms' ? 'mms-button-bg-primary' : 'tech-button-bg-primary'" mat-button (click)="onSubmit()">
        {{ data?.submitLabel || 'WM_TECH_MMS.DIALOG.SUBMIT' | translate }}
      </button>
    </ng-template>
  </div>

  <button mat-button class="close" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>
